import { api } from '../lib/api';

const SERVICE_LABELS = {
  identidade_visual: 'Identidade Visual',
  gestao_trafego: 'Gestão de Tráfego Pago',
  branding: 'Branding',
  planejamento_estrategico: 'Planejamento Estratégico', // legado para tickets antigos
  videomaker: 'Videomaker',
  consultoria_60min: 'Consultoria 60min',
  ebook_request: 'Solicitação de E-book',
};

const STATUS_LABELS = {
  pendente: 'Pendente',
  avaliando: 'Avaliando',
  entrando_em_contato: 'Em Contato',
  trabalhando_nisso: 'Trabalhando Nisso',
  concluido: 'Concluído',
  encerrado: 'Encerrado',
};

const STATUS_COLORS = {
  pendente: 'bg-yellow-100 text-yellow-700',
  avaliando: 'bg-blue-100 text-blue-700',
  entrando_em_contato: 'bg-purple-100 text-purple-700',
  trabalhando_nisso: 'bg-orange-100 text-orange-700',
  concluido: 'bg-green-100 text-green-700',
  encerrado: 'bg-red-100 text-red-700',
};

export const servicesService = {
  // ============================================
  // USER ENDPOINTS
  // ============================================

  async createTicket(formData) {
    const response = await api.post('/api/services/tickets', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async listTickets(params = {}) {
    const response = await api.get('/api/services/tickets', { params });
    return response.data;
  },

  async getActiveCount() {
    const response = await api.get('/api/services/tickets/active-count');
    return response.data;
  },

  async getTicket(ticketId) {
    const response = await api.get(`/api/services/tickets/${ticketId}`);
    return response.data;
  },

  async getMessages(ticketId, since = null) {
    const params = since ? { since } : {};
    const response = await api.get(`/api/services/tickets/${ticketId}/messages`, { params });
    return response.data;
  },

  async sendMessage(ticketId, formData) {
    const response = await api.post(`/api/services/tickets/${ticketId}/messages`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // ============================================
  // ADMIN ENDPOINTS
  // ============================================

  async adminListTickets(params = {}) {
    const response = await api.get('/api/admin/services/tickets', { params });
    return response.data;
  },

  async adminGetTicket(ticketId) {
    const response = await api.get(`/api/admin/services/tickets/${ticketId}`);
    return response.data;
  },

  async adminUpdateStatus(ticketId, status) {
    const response = await api.patch(`/api/admin/services/tickets/${ticketId}/status`, { status });
    return response.data;
  },

  async adminCloseTicket(ticketId, reason) {
    const response = await api.post(`/api/admin/services/tickets/${ticketId}/close`, { reason });
    return response.data;
  },

  async adminGetMessages(ticketId, since = null) {
    const params = since ? { since } : {};
    const response = await api.get(`/api/admin/services/tickets/${ticketId}/messages`, { params });
    return response.data;
  },

  async adminSendMessage(ticketId, formData) {
    const response = await api.post(`/api/admin/services/tickets/${ticketId}/messages`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // ============================================
  // HELPERS
  // ============================================

  helpers: {
    getServiceLabel(type) {
      return SERVICE_LABELS[type] || type;
    },
    getStatusLabel(status) {
      return STATUS_LABELS[status] || status;
    },
    getStatusColor(status) {
      return STATUS_COLORS[status] || 'bg-gray-100 text-gray-700';
    },
    getServiceTypes() {
      return Object.entries(SERVICE_LABELS).map(([value, label]) => ({ value, label }));
    },
    getStatuses() {
      return Object.entries(STATUS_LABELS).map(([value, label]) => ({ value, label }));
    },
    isTicketClosed(status) {
      return status === 'encerrado' || status === 'concluido';
    },
    MAX_ACTIVE_TICKETS: 4,
  },
};
